import { NzModalRef } from 'ng-zorro-antd/modal';
import { Component } from '@angular/core';

@Component({
  selector: 'app-consent-confirm',
  standalone: false,
  templateUrl: './consent-confirm.component.html',
  styleUrl: './consent-confirm.component.scss'
})
export class ConsentConfirmComponent {

  protected countriesList: { id: string, name: string }[] = [
    { id: 'austria', name: 'Austria' },
    { id: 'belgium', name: 'Belgium' },
    { id: 'bulgaria', name: 'Bulgaria' },
    { id: 'croatia', name: 'Croatia' },
    { id: 'cyprus', name: 'Cyprus' },
    { id: 'czech-republic', name: 'Czech Republic' },
    { id: 'denmark', name: 'Denmark' },
    { id: 'estonia', name: 'Estonia' },
    { id: 'finland', name: 'Finland' },
    { id: 'france', name: 'France' },
    { id: 'germany', name: 'Germany' },
    { id: 'greece', name: 'Greece' },
    { id: 'hungary', name: 'Hungary' },
    { id: 'ireland', name: 'Ireland' },
    { id: 'italy', name: 'Italy' },
    { id: 'latvia', name: 'Latvia' },
    { id: 'lithuania', name: 'Lithuania' },
    { id: 'luxembourg', name: 'Luxembourg' },
    { id: 'malta', name: 'Malta' },
    { id: 'netherlands', name: 'Netherlands' },
    { id: 'poland', name: 'Poland' },
    { id: 'portugal', name: 'Portugal' },
    { id: 'romania', name: 'Romania' },
    { id: 'slovakia', name: 'Slovakia' },
    { id: 'slovenia', name: 'Slovenia' },
    { id: 'spain', name: 'Spain' },
    { id: 'sweden', name: 'Sweden' },
    { id: 'iceland', name: 'Iceland' },
    { id: 'liechtenstein', name: 'Liechtenstein' },
    { id: 'norway', name: 'Norway' },
    { id: 'switzerland', name: 'Switzerland' },
    { id: 'uk', name: 'UK' }
  ];


  protected isShowCountriesList = false;


  constructor(
    private dialogRef: NzModalRef<ConsentConfirmComponent>
  ) { }

  protected onCloseModal(): void {
    this.dialogRef.close(false);
  }

  protected onConfirm(): void {
    this.dialogRef.close(true);
  }

  protected onShowCountriesList(): void {
    this.isShowCountriesList = !this.isShowCountriesList;
  }
}
